import { wsService } from "./wsService";

const section = "signings";

function process_files(formData) {
    return wsService.make_post_request(section + "/process-file", formData, {
      responseType: "arraybuffer",
      headers: {
        Accept: "application/vnd.ms-excel",
      },
    });
  }

export const signingService = {
  section,
  process_files
};
